<template>
  <div class="role-edit">
    <el-form
      v-loading="loading"
      :model="userForm"
      :rules="userFormRules"
      ref="userForm"
      status-icon
      label-width="100px"
      style="margin-left: 24px;margin-right: 24px;"
    >
      <el-input
        v-if="isEdit"
        type="hidden"
        v-model="userForm.agentUserId"
      ></el-input>
      <template>
        <el-form-item label="所属代理商" prop="agentId">
          <el-select v-model="userForm.agentId" placeholder="所属代理商">
            <el-option
              v-for="item in agentList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template>
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userForm.username"></el-input>
        </el-form-item>
      </template>
      <el-form-item class="form-footer">
        <el-button @click="onFormCancle">取消</el-button>
        <el-button type="primary" @click="onFormSave">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addAgentUser } from "@/api/agentUser";
import { getAgentList } from "@/api/agentInfo";
export default {
  name: "AgentUserEdit",
  props: {
    isEdit: {
      type: Boolean,
      required: true
    },
    editForm: {
      type: Object,
      required: false
    }
  },
  data: function() {
    let validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        var reg1 = new RegExp("^[a-zA-Z]+$");
        let reg2 = new RegExp("^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$");
        if (!reg1.test(value) && !reg2.test(value)) {
          callback(new Error("只能输入英文字母或者英文字母与数字的组合"));
        }
        callback();
      }
    };
    return {
      loading: false,
      userForm: {
        agentId: null,
        username: null
      },
      userFormRules: {
        agentId: [
          {
            required: true,
            message: "请选择所属合作机构",
            trigger: "change"
          }
        ],
        username: [
          {
            required: true,
            validator: validateUsername,
            trigger: "blur"
          }
        ]
      },
      agentList: []
    };
  },
  watch: {
    editForm: function(value) {
      if (this.isEdit) {
        this.userForm = value;
      }
    }
  },
  mounted: function() {
    if (this.isEdit) {
      this.userForm = this.editForm;
    }
    this.getAgentList();
  },
  methods: {
    getAgentList() {
      let that = this;
      getAgentList().then(res => {
        if (res && res.code === "200") {
          res.data.map(item => {
            that.agentList.push({
              label: item.agentName,
              value: item.agentId
            });
          });
        }
      });
    },
    onFormSave: function() {
      let self = this;
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          self.loading = true;
          if (this.isEdit) {
            console.log(1);
          } else {
            addAgentUser(self.userForm)
              .then(res => {
                if (res.code === "200") {
                  self.$message({
                    message: "新增成功！",
                    type: "success"
                  });
                  self.$emit("onSaveSuccess");
                }
              })
              .finally(function() {
                self.loading = false;
                self.$refs.userForm.resetFields();
                self.$emit("onCancle");
              });
          }
        } else {
          return false;
        }
      });
    },
    onFormCancle: function() {
      this.$emit("onCancle");
    }
  }
};
</script>
